<template>
	<div class="bg5 p4">
		<core-form-input
			class="mb4"
			componentName="j-base-input-text"
			name="name"
			id="name"
			:label="$t('name_of_template')"
			:validationErrors="errors"
			v-model="templateName"
			v-validate="{ required: true }"
		/>
		<core-form-input
			class="mb4"
			componentName="j-base-input-long-text"
			name="description"
			id="description"
			:label="$t('description')"
			v-model="templateDescription"
		/>
		<j-button class="mt6" @click="createNotificationTemplate">{{
			$t("create")
		}}</j-button>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		CoreFormInput,
		JButton
	},

	data() {
		return {
			templateName: null,
			templateDescription: null
		}
	},

	methods: {
		async createNotificationTemplate() {
			const query = gql`
				mutation createNotificationTemplate(
					$input: createNotificationTemplateInput!
				) {
					createNotificationTemplate(input: $input) {
						createdStatus {
							id
						}
					}
				}
			`
			const variables = {
				input: {
					name: this.templateName,
					description: this.templateDescription
				}
			}
			const res = await api({ query, variables })
			const createdId = res?.data?.createNotificationTemplate?.createdStatus?.id

			if (createdId) {
				this.$emit("created:notificationTemplate")
				/*
				this.$router.push({
					name: "NotificationTemplateUpdate",
					params: { id: createdId }
                })
                */
			} else {
				this.$store.dispatch("showError", [this.$t("error.general")])
			}
		}
	}
}
</script>
